import { call, select } from 'redux-saga/effects';

import * as InsuranceAnketaDataProviders from 'data-providers/insuranceAnketa';
import * as InsuranceAnketaConstants from 'store/insuranceAnketa/constants';
import { frontToBackCustomer } from 'store/insuranceAnketa/frontToBackMapper';
import * as InsuranceAnketaSelectors from 'store/insuranceAnketa/selectors';
import * as InsuranceCalculationSelectors from 'store/insuranceCalculation/selectors';

import * as InsuranceConstants from '../../constants';
import * as InsuranceHelpers from '../../helpers';

export const insuranceStageUpdateOwnerCustomer = new InsuranceHelpers.CreateStage({
  action: InsuranceConstants.ACTIONS.UPDATE_OWNER_CUSTOMER,
  handler: function* () {
    const applicationId = yield select(InsuranceCalculationSelectors.selectApplicationId);

    const state = yield select(InsuranceAnketaSelectors.selectInsuranceAnketa);
    const {
      [InsuranceAnketaConstants.FIELDS.FILLED_CUSTOMERS]: customers,
      [InsuranceAnketaConstants.FIELDS.ID]: customerId,
      [InsuranceAnketaConstants.FIELDS.OWNER_IS_DRIVER]: ownerIsDriver,
      [InsuranceAnketaConstants.FIELDS.OWNER_IS_INSURER]: ownerIsInsurer,
    } = state;

    const customer = customers.find(({ id }) => {
      return id === customerId;
    });

    if (!applicationId) {
      InsuranceHelpers.CreateStage.throwError({ message: 'Application ID is missing' });
    }

    if (!customer) {
      InsuranceHelpers.CreateStage.throwError({ message: 'The customer was not found' });
    }

    const customerClone = structuredClone(customer);

    yield* InsuranceHelpers.customerRoleManaging({
      afterDelete: () => {
        InsuranceHelpers.dropDriverLicense({ customer: customerClone });
      },
      customerId,
      feature: ownerIsDriver,
      role: InsuranceAnketaConstants.CUSTOMER_ROLES.DRIVER,
    });
    yield* InsuranceHelpers.customerRoleManaging({
      customerId,
      feature: ownerIsInsurer,
      role: InsuranceAnketaConstants.CUSTOMER_ROLES.INSURER,
    });

    yield call(
      InsuranceAnketaDataProviders.patchCustomer,
      frontToBackCustomer(structuredClone(state), customerClone)
    );
  },
  name: InsuranceConstants.STAGES_FIELDS.UPDATE_OWNER_CUSTOMER,
}).watcher;
